import { render, staticRenderFns } from "./PendingInventoryList.vue?vue&type=template&id=0c703fd2"
import script from "./PendingInventoryList.vue?vue&type=script&lang=js"
export * from "./PendingInventoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports